import { z } from 'zod';

export const CustomRequestPostPositionStartEditRequestSchema = z.record(z.string(), z.string());

export type CustomRequestPostPositionStartEditRequest = z.infer<typeof CustomRequestPostPositionStartEditRequestSchema>;
